import { PromoListPage } from '@/features/promo/pages/PromoListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/promo/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["promo.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: PromoListPage,
})
